import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { navItems as defaultNavItems } from "src/components/left-section/_nav";
import {
  ROLE_RESOURCE_PERMISSIONS,
  ReviewStatus,
} from "src/constants/constants";
import { ApiService } from "./api.service";

@Injectable({
  providedIn: "root",
})
export class NavService {
  private navItemsSubject = new BehaviorSubject<any[]>([...defaultNavItems]);
  public navItems$ = this.navItemsSubject.asObservable();
  private params = [
    {
      key: "reviewStatus",
      value: JSON.stringify([ReviewStatus.Pending]),
    },
    {
      key: "status",
      value: true,
    },
  ];

  constructor(private apiService: ApiService) {}

  setNavItems(newItems: any[]) {
    this.navItemsSubject.next(newItems);
  }

  updateBadge(className: string, count: number = 0, isChild: boolean = false) {
    let updated: any = [];
    if (isChild) {
      updated = this.navItemsSubject.getValue().map((item) =>
        item.children?.length
          ? {
              ...item,
              children: item.children?.map((childNav: any) =>
                childNav?.class === className
                  ? { ...childNav, badge: { text: `${count}` } }
                  : childNav
              ),
            }
          : item
      );
    } else {
      updated = this.navItemsSubject
        .getValue()
        .map((item) =>
          item.class === className
            ? { ...item, badge: { text: `${count}` } }
            : item
        );
    }
    this.setNavItems(updated);
  }

  updateDatasetCount() {
    this.apiService.getDataSetList(this.params, false).subscribe((res) => {
      if (res?.header.success) {
        this.updateBadge(
          ROLE_RESOURCE_PERMISSIONS.ARTEFACT_APPROVALS,
          res?.data?.cards?.total,
          true
        );
      }
    });
  }
  updateModelCount() {
    this.apiService.getModelList(this.params).subscribe((res) => {
      if (res?.header.success) {
        this.updateBadge(
          ROLE_RESOURCE_PERMISSIONS.ARTEFACT_APPROVALS,
          res?.data?.total,
          true
        );
      }
    });
  }
  updateUseCaseCount() {
    this.apiService.getUseCaseList(this.params).subscribe((res) => {
      if (res?.header.success) {
        this.updateBadge(
          ROLE_RESOURCE_PERMISSIONS.ARTEFACT_APPROVALS,
          res?.data?.cards?.total,
          true
        );
      }
    });
  }
}
